// Gift Slider
$(document).ready(function(){
  $('.image-slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    focusOnSelect: false,
    pauseOnFocus : false,
    pauseOnHover : false,
    dots:true,
    prevArrow: '<button class="slide-arrow prev-arrow"><svg class="ourclients_Rotate__3cGKJ" xmlns="http://www.w3.org/2000/svg" width="45.69" height="38.26" viewBox="0 0 45.69 38.26"><path id="Path_29" data-name="Path 29" d="M479.28,663.76l-19.13,19.13-3.18-3.18,13.7-13.7H433.59v-4.5h37.08l-13.7-13.7,3.18-3.18Z" transform="translate(-433.59 -644.63)"></path></svg></button>',
    nextArrow: '<button class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="45.69" height="38.26" viewBox="0 0 45.69 38.26"><path id="Path_29" data-name="Path 29" d="M479.28,663.76l-19.13,19.13-3.18-3.18,13.7-13.7H433.59v-4.5h37.08l-13.7-13.7,3.18-3.18Z" transform="translate(-433.59 -644.63)"></path></svg></button>'
  });
});

// image animation
$(document).ready(function(){
  $('#shopify-section-template--15445616033945__1649139478cabb01ba .text-sec img').css('transform','rotate(360deg)');
});


// Custom Solution page 
// Image slider
$(document).ready(function(){
  $('.gap-image-slider,.pieces-slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    focusOnSelect: false,
    pauseOnFocus : false,
    pauseOnHover : false,
    dots:true,
    prevArrow: '<button class="slide-arrow prev-arrow"><svg class="ourclients_Rotate__3cGKJ" xmlns="http://www.w3.org/2000/svg" width="45.69" height="38.26" viewBox="0 0 45.69 38.26"><path id="Path_29" data-name="Path 29" d="M479.28,663.76l-19.13,19.13-3.18-3.18,13.7-13.7H433.59v-4.5h37.08l-13.7-13.7,3.18-3.18Z" transform="translate(-433.59 -644.63)"></path></svg></button>',
    nextArrow: '<button class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="45.69" height="38.26" viewBox="0 0 45.69 38.26"><path id="Path_29" data-name="Path 29" d="M479.28,663.76l-19.13,19.13-3.18-3.18,13.7-13.7H433.59v-4.5h37.08l-13.7-13.7,3.18-3.18Z" transform="translate(-433.59 -644.63)"></path></svg></button>'
  });

  Fancybox.bind("[data-fancybox]", {
    // Your custom options
  });

  // Article Page Slider
  $('.article-slider-body').slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    focusOnSelect: false,
    pauseOnFocus : false,
    pauseOnHover : false,
    dots:false,
    prevArrow: '<button class="slide-arrow prev-arrow"><svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M-1.90735e-06 8.37383L8.37382 16.7477L9.76581 15.3557L3.76887 9.35872H20V7.38893H3.76887L9.76581 1.39199L8.37382 0L-1.90735e-06 8.37383Z" fill="black"></path></svg></button>',
    nextArrow: '<button class="slide-arrow next-arrow"><svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 8.37383L11.6262 16.7477L10.2342 15.3557L16.2311 9.35872H0V7.38893H16.2311L10.2342 1.39199L11.6262 0L20 8.37383Z" fill="black"></path></svg></button>'
  });
  
});

// Product Page Accordian
$(document).ready(function(){
  var accordion = (function(){

    var $accordion = $('.product-bottom-detail');
    var $accordion_header = $accordion.find('.product-description h3');
    var $accordion_item = $('.product-description');

    // default settings 
    var settings = {
      // animation speed
      speed: 400,

      // close all other accordion items if true
      oneOpen: false
    };

    return {
      // pass configurable object literal
      init: function($settings) {
        $accordion_header.on('click', function() {
          accordion.toggle($(this));

          setTimeout(() => {
                     $('body, html').animate({
            scrollTop: $(this).offset().top - 120
          }, 500)
        }, 400)
      });

      $.extend(settings, $settings); 

      // ensure only one accordion is active if oneOpen is true
       if(settings.oneOpen && $('.product-description.active').length > 1) {
      	$('.product-description.active:not(:first)').removeClass('active');
       }

    // reveal the active accordion bodies
    	$('.product-description.active').find('> .product__description').show();
    },
    toggle: function($this) {

      if(settings.oneOpen && $this[0] != $this.closest('.product-bottom-detail').find('> .product-description.active > h3')[0]) {
        $this.closest('.product-bottom-detail')
        .find('> .product-description') 
        .removeClass('active')
        .find('.product__description')
        .slideUp()
      }

      // show/hide the clicked accordion item
      $this.closest('.product-description').toggleClass('active');
      $this.next().stop().slideToggle(settings.speed);
    }
  }
    })();
 accordion.init({ speed: 300, oneOpen: true });
});

// $(document).ready(function(){
//   $(".product-description:not(:first-of-type) .product__description").css("display", "none");
//   $(".product-description:first-of-type h3").addClass("show");
//   $(".product-description h3").click(function () {
//     $(".show").not(this).removeClass("show").next().slideUp(300);
//     $(this).toggleClass("show").next().slideToggle(300);
//   });
// });

// Replace Text in product page
$(document).ready(function(){
  setTimeout(function() {
    $( ".pplr-optional-gift-tag-message textarea" ).attr('placeholder','Optional Gift Tag Message');
    $( ".pplr-gift-tag-message textarea" ).attr('placeholder','Gift Tag Message');
    var InputValue = $(".pplr_text.pplr_monogram").val();
    if(InputValue != ''){
        $('.pplr_preview_wrapper').show();
        $('.pplr img').css('visibility','hidden');
      }else{
        $('.pplr_preview_wrapper').hide();
        $('.pplr img').css('visibility','visible');
      }
    $(".pplr_text.pplr_monogram").keyup(function(){
      var message = $(this).val();
      if(message != ''){
        $('.pplr_preview_wrapper').show();
        $('.pplr img').css('visibility','hidden');
      }else{
        $('.pplr_preview_wrapper').hide();
        $('.pplr img').css('visibility','visible');
      }
    });
  }, 1000);
  
});  
$(window).on('load',function(){
  setTimeout(function() {
    $( ".pplr-optional-gift-tag-message textarea" ).attr('placeholder','Optional Gift Tag Message')
    $( ".pplr-gift-tag-message textarea" ).attr('placeholder','Gift Tag Message');
    var InputValue = $(".pplr_text.pplr_monogram").val();
    if(InputValue != ''){
        $('.pplr_preview_wrapper').show();
        $('.pplr img').css('visibility','hidden');
      }else{
        $('.pplr_preview_wrapper').hide();
        $('.pplr img').css('visibility','visible');
      }
    $(".pplr_text.pplr_monogram").keyup(function(){
      var message = $(this).val();
      if(message != ''){
        $('.pplr_preview_wrapper').show();
        $('.pplr img').css('visibility','hidden');
      }else{
        $('.pplr_preview_wrapper').hide();
        $('.pplr img').css('visibility','visible');
      }
    });
  }, 1000);
});

// Click To scroll Product page
$(document).ready(function(){
  $( 'a.detail-btn,.option-left a' ).on( 'click', function(e){
    var href = $(this).attr( 'href' );
    $( 'html, body' ).animate({
      scrollTop: $( href ).offset().top - 150
    }, '300' );
    e.preventDefault();
  });
});

// FAQ Page
$(document).ready(function(){
  $(".faq-title").click(function () {
    $(".show").not(this).removeClass("show").next().slideUp(300);
    $(this).toggleClass("show").next().slideToggle(300);
  });
});

// Open Modal
$(document).ready(function(){
  $('.back-innerbody a').click(function(event){
    $('body').addClass('modal-open');
    event.stopPropagation();
  });
  $('.modal-close a').click(function(){
    $('body').removeClass('modal-open');
    $(".modal-content").hide();
  });

  $('.modal-body').click(function(event){
    event.stopPropagation();
  });

  $(document).click(function() { 
    $('body').removeClass('modal-open');
    $(".modal-content").hide();
    $('.back-modal .modal-content').removeClass('show');
  });

  $('.back-innerbody a').click(function(){
    let currentTab = $(this).attr('href');
    $('.back-modal .modal-content').hide();
    $('.back-modal .modal-content').removeClass('show');
    $(currentTab).show();
    $(currentTab).addClass('show');
  });

});

// pagination in giving back modal
$(window).on('load',function(){
  $(".modal-content").each(function(e) {
    $(this).hide();
  });
});
$(document).ready(function(){
  $(".modal-content").each(function(e) {
    $(this).hide();
  });

  $(".next").click(function(){
    if ($(".modal-content:visible").next().length != 0)
      $(".modal-content:visible").next().addClass('show').show().prev().removeClass('show').hide();
    else {
      $(".modal-content:visible").hide();
      $(".modal-content:first").show();
    }
    return false;
  });

  $(".prev").click(function(){
    if ($(".modal-content:visible").prev().length != 0)
      $(".modal-content:visible").prev().addClass('show').show().next().removeClass('show').hide();
    else {
      $(".modal-content:visible").hide();
      $(".modal-content:last").show();
    }
    return false;
  });

  $(".modal-btn button").click(function (){
    $('.modal-content').animate({
      scrollTop: $(".modal-content").offset().top
    }, 800);
  });

});

// Collection page filter
$(document).ready(function () {
  var e = [],
      t = "";
  $('.tag-group input[type="radio"]').change(function (o) {
    o.preventDefault(),
      setTimeout(function () {
      (e = []),
        $(".tag-group input:checked").each(function () {     
        $('.reset-filter').addClass('show-btn');
        e.push($(this).val());
      });
      var n = e.join("+"),
          a = location.pathname,
          l = location.origin,
          u = l + a + "/" + n;

      $('.skeleton,.filter-skeleton').show();
      $('.product-grid-body li .card-wrapper').css({"opacity": "0", "visibility": "hidden"});
      console.log(u),
        $.ajax({
        url: u,
        type: "GET",
        success: function (d) {
          $('.product-grid-body li .card-wrapper,.collection--empty,.filter-group .filter-group-body').css({"opacity": "0", "visibility": "hidden"});
          setTimeout(function() {
            $('.skeleton,.filter-skeleton').hide();
            $('.product-grid-body li .card-wrapper,.collection--empty,.filter-group .filter-group-body').css({"opacity": "1", "visibility": "visible"});
            $(".product-grid-body").html($(d).find(".product-grid-body").html());
          }, 500);
        },
      });
    }, 200);
  });

  $('.reset-filter').click(function(){
    $('.filter-group input[type="radio"]').prop('checked', false);
    var g = location.pathname,
        h = location.origin,
        j = h+g;
    $('.skeleton,.filter-skeleton').show();
    $('.product-grid-body li .card-wrapper').css({"opacity": "0", "visibility": "hidden"});
    $.ajax({
      url: j,
      type: "GET",
      success: function (d) {
        $('.product-grid-body li .card-wrapper,.collection--empty,.filter-group .filter-group-body').css({"opacity": "0", "visibility": "hidden"});
        setTimeout(function() {
          $('.skeleton,.filter-skeleton').hide();
          $('.product-grid-body li .card-wrapper,.collection--empty,.filter-group .filter-group-body').css({"opacity": "1", "visibility": "visible"});
          $(".product-grid-body").html($(d).find(".product-grid-body").html());
        }, 500);
      },
    });
    $(this).removeClass('show-btn');
  });
});

// Mobile Filter
$(document).ready(function(){
  $('.mobile-filter-handle').click(function(){
    $('body').addClass('filter-open');
  });
  $('.filter-backdrop,.filter-close,.sidebar__filter-item,.reset-filter').click(function(){
    $('body').removeClass('filter-open');
  });
  $('.customization-filter').removeAttr('id');
});

// Cart Page
$( window ).on("load", function() {
  $('.product-option dt').each(function(){
  var hhh = $(this).text();
  if(hhh === 'Cookie Preview1: '){
    $(this).text('Gift Text Preview: ');
  }
});
});

// Carrer Page
$(document).ready(function() {
  if($('.career-form-wrapper').hasClass('career-form-sec')){
    $('body').addClass('show-career-form');
  }
});
// Volume Discounts
$(document).ready(function() {
    $(".discount-table").on('scroll', function() {
        $val = $(this).scrollLeft();
    });
    console.log('init-scroll: ' + $(".nav-next").scrollLeft());
    $(".nav-next").on("click", function() {
        $(".discount-table").animate({
            scrollLeft: '+=200'
        }, 200);

    });
    $(".nav-prev").on("click", function() {
        $(".discount-table").animate({
            scrollLeft: '-=200'
        }, 200);
    });
});

 
$(document).ready(function(){
  var productLength = $('[product-id="4745124184201"]').length;
  if(productLength == 0){
    setTimeout(function(){
       $('[item-id="33789754933385"] [name="minus"]').trigger('click');
    }, 300);
  }
});

let cart_update = $.getJSON('/cart.js');
  // wait for the response
  cart_update.done(function(){
    //when you have the response, get the JSON and set items to cart.items
    cart_update = cart_update.responseJSON;
    let items = cart_update.items;
    // make a boolean to make sure that the item you want to add isnt already in the cart (to keep the JS from firing again on page reload)
    let item_in_cart_already = false;
    
    for (var i = 0; i < items.length; i++) {
        if (items[i].product_id == '7409468637337') {
            item_in_cart_already = true;
        }
    	if (items[i].product_id == '7423655608473') {
            item_in_cart_already = true;
        }
        if (items[i].product_id == '7423556944025') {
            item_in_cart_already = true;
        }
      
    }
    if (item_in_cart_already) {
        for (var i = 0; i < items.length; i++) {
            if (items[i].product_id == '7409468637337') {
                $('.cart-note-wrapper ').show();
            }
    		if(items[i].product_id == '7423655608473'){
    			$('.cart-note-wrapper ').show();
    		}
    		if(items[i].product_id == '7423556944025'){
    			$('.cart-note-wrapper ').show();
    		}
        }
    }
  })
// =================================================================

$(document).ready(function(){
  setInterval(function () {
    var attr = $('.my-cart__app-container iframe').attr('style');
    if (typeof attr !== 'undefined' && attr !== false) {
      $('.rise-loader').hide();
    }else{
      $('.rise-loader').show();
    }
  }, 1000);
});